import axios from 'axios'
import { config } from '../config/config'

export const api = axios.create({
  baseURL: config.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para agregar token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Solo redirigir si no estamos ya en login o register
      if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/register')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// Servicio local para comandos
export const commandService = {
  sendCommand: (deviceId, comando) => api.post(`/dispositivos/comando`, { device_id: deviceId, command: comando }),
  sendExternalCommand: (deviceId, comando) => api.post(`/dispositivos/comando-externo`, { device_id: deviceId, comando }),
}

export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  me: () => api.get('/auth/me'),
}

export const deviceService = {
  getAll: (params) => api.get('/devices', { params }),
  getById: (id) => api.get(`/devices/${id}`),
  create: (data) => api.post('/devices', data),
  update: (id, data) => api.put(`/devices/${id}`, data),
  updateStatus: (id, status, additionalFields = {}) => api.patch(`/devices/${id}/status`, { status, ...additionalFields }),
  delete: (id) => api.delete(`/devices/${id}`),
  block: (id) => api.patch(`/devices/${id}/block`),
  unblock: (id) => api.patch(`/devices/${id}/unblock`),
  updateLastSeen: (id) => api.patch(`/devices/${id}/update-last-seen`),
  sendCommand: (deviceId, comando, parametros = {}) => api.post(`/comando/${deviceId}`, { comando, parametros }),
  revivirConexion: (id) => api.post(`/devices/${id}/revivir-conexion`),
}

export const companyService = {
  getAll: (params) => api.get('/companies', { params }),
  getById: (id) => api.get(`/companies/${id}`),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`),
}

export const licenseService = {
  getAll: (params) => api.get('/licenses', { params }),
  getById: (id) => api.get(`/licenses/${id}`),
  create: (data) => api.post('/licenses', data),
  update: (id, data) => api.put(`/licenses/${id}`, data),
  delete: (id) => api.delete(`/licenses/${id}`),
  generateMultiple: (data) => api.post('/licenses/generate-multiple', data),
}

export const userService = {
  getAll: (params) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
}

export const dispositivoService = {
  sendCommand: (data) => api.post('/dispositivos/comando', data),
  sendExternalCommand: (data) => api.post('/dispositivos/comando-externo', data),
  block: (data) => api.post('/dispositivos/bloquear', data),
  unblock: (data) => api.post('/dispositivos/desbloquear', data),
  create: (data) => api.post('/dispositivos/crear', data),
} 